import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';

import dsd from "../classes/clsDSD";
import {listSolutions} from '../utils/utilsSolution';

import * as PD from '../classes/pdStyle';

class ListSolutions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            Solutions : null
        };


        this.dsd = new dsd();
        this.dsd.StateObject = this;

    }

componentDidMount(){

    this.setup();
 
}


componentDidUpdate(prevProps, prevState){

   if (!isEqual(this.props, prevProps)){
       this.setup();
   }
   return;

}

loadData(filters={}){
    const onLoad = (data) => {
        this.setState({
            isLoaded: true,
            Solutions: data
        });

        if (this.state.onLoad){
            this.state.onLoad(data.length);
        }

    }
  
    const onFail = (error) => {
        this.setState({
            isFailed: true,
            isLoaded: false
        });
    }

    listSolutions(this.dsd, filters, onLoad, onFail);

}

setup(){

    let StateChange = {
        data: null,
        columns: {
            owner:true,
            status:true
        },
        load: false,
        onLoad: null
    }

    let filters = getParam('filters', this.props);

    if (getParam('columns', this.props)){
        StateChange.columns = getParam('columns', this.props);
    }

    if (getParam('onLoad', this.props)){
        StateChange.onLoad = getParam('onLoad', this.props);
    }

   this.setState(StateChange, () => {
       this.loadData(filters);
   });
        
}



    included(Solution) {

        let IncludeThis = true;

        return IncludeThis;
    }

    render() {


        if (this.state.isFailed) {
            return (
                <PD.ErrorBox>
                    A problem has occurred
                </PD.ErrorBox>
            )
        }


        if (this.state.isLoaded) {
            let arrSolutions = this.state.Solutions;
            if (isArray(arrSolutions)){
                if (arrSolutions.length > 0){

                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Name</PD.Th>
                                    {this.state.columns.owner &&
                                        <PD.Th>Owner</PD.Th>                            
                                    }
                                    {this.state.columns.status &&
                                        <PD.Th>Status</PD.Th>                            
                                    }
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>

                            {
                                arrSolutions.map(
                                    (Solution, pos) => 
                                    {
                                        if (this.included(Solution)) {

                                            let maxRows = 1;

                                            let Rows = []
                                            for (let i = 1; i <= maxRows; i++) {
                                                Rows.push(null);
                                            }
                
                                            return (

                                                    <PD.Tr key={pos}>
                                                        <PD.Td>
                                                            <PD.PdNavLink to={"/solution/" + Solution.id} > {Solution.name}</PD.PdNavLink>
                                                        </PD.Td>
                                                        {this.state.columns.owner &&
                                                            <PD.Td>
                                                                {Solution.Owner &&
                                                                    Solution.Owner.organisation}
                                                            </PD.Td>
                                                        }
                                                        {this.state.columns.status &&
                                                            <PD.Td>
                                                                {Solution.status}
                                                            </PD.Td>
                                                        }                                                        
                                                        <PD.Td>
                                                            <PD.MdPresent>{truncate(Solution.description, 400)}</PD.MdPresent>
                                                        </PD.Td>

                                                    </PD.Tr>

                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>

                        </PD.Table>
                    )
                }
            }
        }

        return <div />;

    };    
};
        
export default function ListSolutions_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListSolutions {...props} navigation={navigation} location={location} params={params} />;
  }
